import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Tooltip,
  Cascader,
  Select,
  Row,
  Col,
  Checkbox,
  Button,
  Card,
  AutoComplete,
  Popconfirm,
  Tag,
  Modal,
} from "antd";
import { Table } from "ant-table-extensions";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useFormDetail } from "../../../util/dataProvider";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
import { SearchOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
const { Option } = Select;
const AutoCompleteOption = AutoComplete.Option;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
// rowSelection object indicates the need for row selection
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User", // Column configuration not to be checked
    name: record.name,
  }),
};

const Registration = () => {
  const [form] = Form.useForm();
  const [editform] = Form.useForm();
  let history = useHistory();

  const [visible, setVisible] = useState(false);
  const [editvisible, setEditvisible] = useState(false);
  const {
    loading,
    success,
    setSuccess,
    getBookNoteList,
    bookList,
   // setEditBook,
    getClassList,
    getSubjectListByClass,
    createBook,
    classList,
    subjectListByClass,
    getDeleteBook,
    updateBook
  } = useFormDetail();
  const [showMessage, setShowMessage] = useState('');
  const [editBook, setEditBook] = useState(null);
  const columns = [
    {
      title: "Class Name",
      dataIndex: "classname",
    },

    {
      title: "Subject Name",
      dataIndex: "subjectname",
    },
    {
      title: "Book Name",
      dataIndex: "name",
      // render: text => <span className="gx-link">{text}</span>,
    },

    {
      title: "Number of Pages",
      dataIndex: "numberofpage",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      render: (text, record) => (
        <span>
          <span className="gx-link">
            <Tag
              onClick={() => {
               
               setEditvisible(true);
               setEditBook(record);
               editform.setFieldsValue({
                name: record.name,
                numberofpage: record.numberofpage,
                classId: {key:record.classId,label:record.classname},
                subjectId: record.subjectId,   
                id: record.id,


               });
                //history.push("/main/edit-book");
              }}
              color="#038fdd"
            >
              Edit
            </Tag>
          </span>
          <span className="gx-link">
            <Popconfirm
              title="Are you sure want to delete this stock?"
              onConfirm={() => onDelete(record.id)}
              okText="Yes"
              cancelText="No"
              okButtonProps={{
                type: "default",
                style: { backgroundColor: "#A2A08A4D", color: "#000" },
              }}
              cancelButtonProps={{
                type: "default",
                style: { backgroundColor: "red", color: "#fff" },
              }}
            >
              <Tag color="#f50">Delete</Tag>
            </Popconfirm>
          </span>
        </span>
      ),
    },
  ];
  useEffect(() => {
    if (success) {
      //form.resetFields();
      NotificationManager.success(showMessage, "Success");

      setSuccess(false);
      form.resetFields();
      setTimeout(() => {
        getBookNoteList({ type: "book" });
        setVisible(false);
        setEditvisible(false);
        NotificationManager.listNotify.forEach((n) =>
          NotificationManager.remove({ id: n.id })
        );
        history.push("/main/books-type");
        setShowMessage("");
      }, 1000);
    }
  }, [success]);

  useEffect(() => {
    getClassList();
    getSubjectListByClass();
    getBookNoteList({ type: "book" });
  }, []);
  const onDelete = (id) => {
    getDeleteBook({ id: id });
    setShowMessage("Book Deleted Successfully");
  };

  const onFinish = (values) => {
    // alert(JSON.stringify(values));
    console.log("Received values of form: ", values);
    values.category = "book";
    createBook(values);
    setShowMessage("Book Saved Successfully");
  };
  const onFinishEdit = (values) => {
    // alert(JSON.stringify(values));
    console.log("Received values of form: ", editBook.id);
    values.id = editBook.id;
    values.classId=values.classId && values.classId.key?values.classId.key:values.classId;
    //typeof(values.classId) === "object" ? (values.classId = values.classId.key) : values.classId;
    //setEditBook(values);
    //alert(values.classId) 
    updateBook(values);
    setShowMessage("Book Updated Successfully");
  };
  function handleChange(value) {
    // getSubjectListByClass({classId:value})
    console.log(`selected ${value}`);
  }

  function handleBlur() {
    console.log("blur");
  }

  function handleFocus() {
    console.log("focus");
  }
  const handleOk = () => {
    // this.setState({
    //   ModalText: 'The modal will be closed after two seconds',
    //   confirmLoading: true,
    // });
    setTimeout(() => {
      setVisible(false);
    }, 2000);
  };
  const handleCancel = () => {
    editform.resetFields();
    setEditBook(null);
    console.log("Clicked cancel button");
    setVisible(false);
    setEditvisible(false);
   
   
  };

  return (
    <div>
      <Card
        title="Books List"
        extra={
          <Button type="primary" onClick={() => setVisible(true)}>
            Add Book
          </Button>
        }
      >
        <Table
          className="gx-table-responsive"
          bordered
          columns={columns}
          dataSource={bookList}
          searchable
        />

        <NotificationContainer />
      </Card>
      <Modal
        title="Add Book"
        visible={visible}
        onOk={handleOk}
        // confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={false}
        width={"50%"}
      >
        <Form
          {...formItemLayout}
          form={form}
          name="bookRegister"
          onFinish={onFinish}
          scrollToFirstError
        >
          <Form.Item
            name="classId"
            label={<span>Select Class &nbsp;</span>}
            // rules={[{ required: true, message: 'Please Select Class', whitespace: true }]}
          >
            <Select
              showSearch
              //style={{width: 200}}
              name="classId"
              placeholder="Select a class"
              optionFilterProp="children"
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {classList.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.classname}
                </Option>
              ))}
            </Select>
          </Form.Item>

          

          <Form.Item
            name="subjectId"
            label={<span>Select Subject &nbsp;</span>}
            // rules={[{ required: true, message: 'Please Select Class', whitespace: true }]}
          >
            <Select
              showSearch
              //style={{width: 200}}
              name="subjectId"
              placeholder="Select a subject"
              optionFilterProp="children"
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {subjectListByClass.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.subjectname}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="name"
            label={<span>Book name&nbsp;</span>}
            rules={[
              {
                required: true,
                message: "Please enter book name",
                whitespace: true,
              },
            ]}
          >
            <Input placeholder="Enter Book Name" />
          </Form.Item>

          <Form.Item
            name="numberofpage"
            label={<span>Number Of Pages &nbsp;</span>}
            // rules={[{ required: true, message: 'Please enter number of page', whitespace: true }]}
          >
            <Input
              type="number"
              name="numberofpage"
              placeholder={"Enter number of book page"}
            />
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" loading={loading} htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>


      <Modal
        title="Edit Book"
        visible={editvisible}
        onOk={handleOk}
        // confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={false}
        width={"50%"}
      >
      
        <Form
          {...formItemLayout}
          form={editform}
          name="editBookRegister"
          onFinish={onFinishEdit}
          scrollToFirstError
        >
          <Form.Item
            name="classId"
            label={<span>Select Class &nbsp;</span>}
            // rules={[{ required: true, message: 'Please Select Class', whitespace: true }]}
          >
            <Select
              showSearch
              //style={{width: 200}}
              name="classId"
              placeholder="Select a class"
              optionFilterProp="children"

              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {classList.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.classname}
                </Option>
              ))}
            </Select>
          </Form.Item>
          

          <Form.Item
            name="subjectId"
            label={<span>Select Subject &nbsp;</span>}
            // rules={[{ required: true, message: 'Please Select Class', whitespace: true }]}
          >
            <Select
              showSearch
              //style={{width: 200}}
              name="subjectId"
              placeholder="Select a subject"
              optionFilterProp="children"
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {subjectListByClass.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.subjectname}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="name"
            label={<span>Book name&nbsp;</span>}
            //initialValue={editBook && editBook.name}
            
            
            rules={[
              {
                required: true,
                message: "Please enter book name",
                whitespace: true,

              },
            ]}
          >
            <Input placeholder="Enter Book Name" value={editBook && editBook.name} />
          </Form.Item>

          <Form.Item
            name="numberofpage"
            label={<span>Number Of Pages &nbsp;</span>}
            
            // rules={[{ required: true, message: 'Please enter number of page', whitespace: true }]}
          >
            <Input
              type="number"
              name="numberofpage"
              placeholder={"Enter number of book page"}
              value={editBook? editBook.numberofpage:''}
            />
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" loading={loading} htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      
      </Modal>
    </div>
  );
};

export default Registration;
